<template>
    <ColumnPicker
      ref="picker"
      v-bind="$attrs"
      v-on="$listeners"
      :class="containerClass"
      variant="light border-muted"
      :value="columns_"
      :options="getChoices(fields, item, columns)"
      tooltip="View Settings"
    >
      <template #button-content>
        <IconEye class="fill-color" :class="{'text-primary': columns !== columnsDefault}" width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true"/>
      </template>
      <template #extra>
        <b-button
          v-if="columns !== columnsDefault"
          variant="link"
          class="btn-sm p-0"
          title="Reset"
          @click.stop="$emit('input', columnsDefault)"
        ><BIconArrowCounterclockwise/></b-button>
      </template>
    </ColumnPicker>
</template>

<script>
import { startCase, lowerCase } from 'lodash'
import IconEye from '@primer/octicons/build/svg/eye-16.svg'
import { BIconArrowCounterclockwise } from 'bootstrap-vue'

import ColumnPicker from './-column-picker.vue'
import { mediaBreakpointUp } from '@/utils/breakpoints.js'

export default {
  name: 'ColumnPickerManage',
  components: {
    BIconArrowCounterclockwise,
    ColumnPicker,
    IconEye,
  },
  inheritAttrs: false,
  props: {
    containerClass: null,
    columns: String,
    columnsDefault: String,
    fields: Array,
    fieldsActive: Array,
    item: Object,
  },
  data() {
    return {
      columns_: this.getColumns(),
    }
  },
  watch: {
    columns() {
      this.columns_ = this.getColumns()
    },
    columns_: {
      handler(val) {
        this.$emit('update:fieldsActive', getFields(val, this.fields))
      },
      immediate: true,
    },
  },
  async created() {
    window.addEventListener('resize', this.onResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    getChoices,
    onResize() {
      // auto-hide columns on small screens
      this.columns_ = this.getColumns()
    },
    getColumns() {
      return this.columns ?? getAutoColumns(this.fields)
    },
  },
}

function getAutoColumns(fields) {
  return fields
    ?.filter(({autoshow = 'xs'} = {}) => mediaBreakpointUp(autoshow))
    .map(field => field.key)
    .join(',')
}
function getChoices(fields, item, columns) {
  const fieldsDict = fields?.reduce((acc, cur) => ({...acc, [cur.key]: cur}), {})
  const columnsDict = columns?.split(',').reduce((acc, cur) => ({...acc, [cur]: true}), {})
  // add choices for all fields, item properties, and user-specified columns; sort the fields first
  const choices = Object.keys({
    ...fieldsDict,
    ...item,
    ...columnsDict,
  })
  return choices
    // remove b-table fields e.g. _cellVariants
    .filter(i => i.indexOf('_') !== 0)
    // format for b-form-checkbox-group
    .map(key => {
      const field = fieldsDict[key]
      const labelParts = [field?.label, field?.thAttr?.title]
        .filter(i => i !== undefined)
      const label = labelParts.length ? labelParts.join(' ') : undefined
      return {
        value: key,
        text: label ?? startCase(lowerCase(key)),
      }
    })
}

function getFields(columns, fields) {
  // return a list of fields for a given columns string
  if (!columns) { return }
  return columns.split(',').map(col => {
    const field = fields?.find(i => i.key === col) || { key: col }
    return field
  })
}
</script>
